"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getRouteFromUrl = function getRouteFromUrl(url) {
  if (!url) return;
  if (firstWord({
    url: url,
    word: "article/"
  })) return "article";
  if (firstWord({
    url: url,
    word: "inspirations"
  })) return "inspirations";
  if (firstWord({
    url: url,
    word: "promotions"
  })) return "promotions";
  if (firstWord({
    url: url,
    word: "info/"
  })) return "info";
  if (firstWord({
    url: url,
    word: "newsletter/signup"
  })) return "newsletter-signup";
  if (firstWord({
    url: url,
    word: "newsletter/signoff"
  })) return "newsletter-signoff";
  return "category-page";
};
var firstWord = function firstWord(_ref) {
  var url = _ref.url,
    word = _ref.word;
  if (url[0] === "/") {
    url = url.slice(1);
  }
  return url.substring(0, word.length).includes(word);
};
var _default = getRouteFromUrl;
exports["default"] = _default;